module.exports = __webpack_public_path__ + "img/chr_ts_90_5.b82c9e32.png";